// extracted by css-extract-rspack-plugin
var _1 = "Login-m_auth-fjefWfiB dim-button";
var _2 = "Login-m_billboard-CQh4wkJp";
var _3 = "Login-m_dimSync-ZaM3rhfS Login-m_section-J11pfJz5";
var _4 = "Login-m_dimSyncCheckbox-mpMffwmt";
var _5 = "Login-m_explanation-UfEk4VyZ";
var _6 = "Login-m_fineprint-MwpOJrxH";
var _7 = "Login-m_section-J11pfJz5";
var _8 = "Login-m_warning-AYaiBXQB";
export { _1 as "auth", _2 as "billboard", _3 as "dimSync", _4 as "dimSyncCheckbox", _5 as "explanation", _6 as "fineprint", _7 as "section", _8 as "warning" }
